import GuideIcon from "@mui/icons-material/MenuBook";
import { Button } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import { useTheme } from "../../context/ThemeContext.tsx";
import { useGuide } from "./GuideContext.tsx";

/** How strongly the button is washed with the primary colour while the guide is open. */
const OPEN_ALPHA = 0.1;

/**
 * Opens and closes the guide of the page, from the page's header. There is
 * nothing to open on a page without a guide, or outside a case's pages.
 */
export const GuideButton = () => {
  const guide = useGuide();
  const { theme } = useTheme();
  const { t } = useTranslation(undefined, { keyPrefix: "guide" });
  if (guide?.page === undefined) return null;

  return (
    <Button
      variant="outlined"
      startIcon={<GuideIcon />}
      aria-expanded={guide.shown}
      aria-controls="guide"
      onClick={() => guide.dispatch({ type: "toggle" })}
      sx={{
        textTransform: "none",
        fontWeight: 600,
        flex: "none",
        bgcolor: guide.shown
          ? alpha(theme.palette.primary.main, OPEN_ALPHA)
          : undefined,
      }}
    >
      {t("button")}
    </Button>
  );
};
